import { Redirect } from 'expo-router';

export default function GlobalAppIndexRedirect() {
  return <Redirect href="/app/home" />;
}
